// Test IDs for the ROOTS platform (non-auth features).
export const APP = {
  // top bar / shell
  brand: 'app-brand',
  entitySelect: 'context-entity-select',
  siteSelect: 'context-site-select',
  contractSelect: 'context-contract-select',
  zoneSelect: 'context-zone-select',
  roleBadge: 'app-role-badge',
  lestariStatus: 'lestari-sync-status',
  lestariSyncBtn: 'lestari-sync-button',
  fieldModeBtn: 'field-mode-button',
  userMenu: 'app-user-menu',

  // nav
  navDashboard: 'nav-dashboard',
  navSetup: 'nav-setup',
  navProject: 'nav-project',
  navTeam: 'nav-team',
  navTender: 'nav-tender',
  navAudit: 'nav-audit',
};

export const ABOUT = {
  trigger: 'about-menu-item',
  dialog: 'about-dialog',
  build: 'about-build',
  version: 'about-version',
  env: 'about-environment',
};

export const WIZARD = {
  root: 'wizard-root',
  openLauncher: 'setup-start-project',
  launcher: 'wizard-launcher',
  trackWon: 'wizard-track-won',
  trackTender: 'wizard-track-tender',
  contractSelect: 'wizard-contract-select',
  startBtn: 'wizard-start-button',
  resumeRow: (id) => `wizard-resume-${id}`,
  view: 'wizard-view',
  overall: 'wizard-overall-progress',
  phase: (k) => `wizard-phase-${k}`,
  item: (k) => `wizard-item-${k}`,
  itemJump: (k) => `wizard-jump-${k}`,
  itemTick: (k) => `wizard-tick-${k}`,
  resetBtn: 'wizard-reset-button',
  backBtn: 'wizard-back-button',
};

export const TOUR = {
  startBtn: (k) => `tour-start-${k}`,
  overlay: 'tour-overlay',
  card: 'tour-card',
  title: 'tour-step-title',
  next: 'tour-next',
  back: 'tour-back',
  skip: 'tour-skip',
  panel: 'tour-panel',
};

export const TENDERAI = {
  panel: 'tender-ai-panel',
  fileInput: 'tender-ai-file-input',
  uploadBtn: 'tender-ai-upload-btn',
  docRow: (id) => `tender-ai-doc-${id}`,
  removeDoc: (id) => `tender-ai-remove-${id}`,
  runBtn: 'tender-ai-run',
  results: 'tender-ai-results',
  readiness: 'tender-ai-readiness',
  bulkWoBtn: 'tender-ai-bulk-wo',
  matrixRow: (i) => `tender-ai-matrix-${i}`,
  matrixStatus: (i) => `tender-ai-matrix-status-${i}`,
  matrixAction: (i) => `tender-ai-matrix-action-${i}`,
  matrixActionBox: (i) => `tender-ai-matrix-actionbox-${i}`,
  gapWoBtn: (i) => `tender-ai-gap-wo-${i}`,
  gapWoOpen: (i) => `tender-ai-gap-wo-open-${i}`,
  introInput: 'tender-ai-intro',
  outlineInput: 'tender-ai-outline',
  saveEdits: 'tender-ai-save-edits',
  usePackBtn: 'tender-ai-use-pack',
};

export const DASHBOARD = {
  root: 'dashboard-root',
  statSites: 'stat-sites',
  statContracts: 'stat-contracts',
  statOpenWo: 'stat-open-work-orders',
  statVerify: 'stat-needs-verification',
  statOffTrack: 'stat-off-track',
  statPacks: 'stat-evidence-packs',
  cockpit: 'dashboard-cockpit',
  actKpis: 'cockpit-kpis-awaiting',
  actReady: 'cockpit-scores-ready',
  actBlocked: 'cockpit-scores-blocked',
  actCritical: 'cockpit-open-critical',
  actEnding: 'cockpit-contracts-ending',
  actTenderGaps: 'cockpit-tender-gaps',
  insTrend: 'cockpit-trend',
  insPillarMix: 'cockpit-pillar-mix',
  insBands: 'cockpit-band-dist',
  insEvidence: 'cockpit-evidence-quality',
  insProvenance: 'cockpit-provenance',
};

export const SETUP = {
  root: 'setup-root',
  tab: (k) => `setup-tab-${k}`,
  addBtn: (k) => `setup-add-${k}`,
  dialog: 'setup-dialog',
  saveBtn: 'setup-save-button',
  row: (k, id) => `setup-${k}-row-${id}`,
  editBtn: (k, id) => `setup-${k}-edit-${id}`,
  deleteBtn: (k, id) => `setup-${k}-delete-${id}`,
  field: (name) => `setup-field-${name}`,
  selectRow: (k, id) => `setup-select-${k}-${id}`,
  selectAll: (k) => `setup-select-all-${k}`,
  bulkEditBtn: (k) => `setup-bulk-edit-${k}`,
  bulkDialog: 'setup-bulk-dialog',
  bulkSaveBtn: 'setup-bulk-save-button',
  bulkField: (name) => `setup-bulk-field-${name}`,
  bulkFieldToggle: (name) => `setup-bulk-toggle-${name}`,
  recordAudit: 'setup-record-audit',
  completeness: 'setup-completeness',
};

export const TEAM = {
  root: 'team-root',
  addBtn: 'team-add-user',
  dialog: 'team-dialog',
  saveBtn: 'team-save-button',
  row: (id) => `team-row-${id}`,
  deleteBtn: (id) => `team-delete-${id}`,
  nameInput: 'team-name-input',
  emailInput: 'team-email-input',
  passwordInput: 'team-password-input',
  roleSelect: 'team-role-select',
  demoCard: 'team-demo-card',
  demoReset: 'team-demo-reset',
  demoAnon: 'team-demo-anonymise',
  demoScale: 'team-demo-scale',
  demoDialog: 'team-demo-dialog',
  demoConfirm: 'team-demo-confirm',
};

export const PROJECT = {
  root: 'project-root',
  tab: (k) => `project-tab-${k}`,
};

export const DIAGNOSE = {
  addDefect: 'diagnose-add-defect',
  addIntervention: 'diagnose-add-intervention',
  defectRow: (id) => `defect-row-${id}`,
  interventionRow: (id) => `intervention-row-${id}`,
  approveBtn: (id) => `intervention-approve-${id}`,
  raiseWoBtn: (id) => `intervention-raise-wo-${id}`,
  saveBtn: 'diagnose-save-button',
  field: (n) => `diagnose-field-${n}`,
};

export const WORKORDERS = {
  root: 'work-orders-root',
  addBtn: 'work-order-add',
  row: (id) => `work-order-row-${id}`,
  statusBadge: (id) => `work-order-status-${id}`,
  detailDialog: 'work-order-detail-dialog',
  advanceBtn: (id) => `work-order-advance-${id}`,
  verifyBtn: (id) => `work-order-verify-${id}`,
  saveBtn: 'work-order-save-button',
  field: (n) => `work-order-field-${n}`,
  photoFlag: (id) => `wo-photo-flag-${id}`,
};

export const FIELD = {
  root: 'field-work-root',
  backBtn: 'field-back-button',
  safetyBtn: 'field-safety-confirm',
  taskCard: (id) => `field-task-${id}`,
  captureDialog: 'field-capture-dialog',
  addQty: 'field-add-quantity',
  addLabour: 'field-add-labour',
  photoInput: 'field-photo-input',
  submitBtn: 'field-submit-button',
  annotateDialog: 'field-annotate-dialog',
  annotateSave: 'field-annotate-save',
  annotateSkip: 'field-annotate-skip',
  pairBefore: 'field-pair-before',
  pairAfter: 'field-pair-after',
  pairSave: 'field-pair-save',
  aiPanel: 'field-ai-suggestions',
  aiBusy: 'field-ai-busy',
  aiApplyAll: 'field-ai-apply-all',
  aiApplyCaption: 'field-ai-apply-caption',
  aiApplyNotes: 'field-ai-apply-notes',
  aiAddQty: 'field-ai-add-quantity',
  aiAddLabour: 'field-ai-add-labour',
  aiQuality: 'field-ai-quality',
  voiceBtn: 'field-voice-note',
  voiceStop: 'field-voice-stop',
  suggestPairBtn: 'field-suggest-pair',
  pendingBadge: 'field-pending-badge',
};

export const PERFORMANCE = {
  root: 'performance-root',
  addBtn: 'indicator-add',
  card: (id) => `indicator-card-${id}`,
  addReadingBtn: (id) => `indicator-reading-${id}`,
  correctiveBtn: (id) => `indicator-corrective-${id}`,
  saveBtn: 'performance-save-button',
  field: (n) => `performance-field-${n}`,
  weatherLegend: 'performance-weather-legend',
};

export const RECOVERY = {
  root: 'recovery-tracker',
  pct: 'recovery-pct',
  stat: (k) => `recovery-stat-${k}`,
  row: (id) => `recovery-driver-${id}`,
};

export const VALUECALC = {
  root: 'value-calc-root',
  addBtn: 'value-calc-add',
  card: (id) => `value-calc-card-${id}`,
  saveBtn: 'value-calc-save-button',
  benchLibBtn: 'value-calc-bench-library',
  benchLibDialog: 'value-calc-bench-dialog',
  benchLibSave: 'value-calc-bench-save',
  presetBtn: (i) => `value-calc-bench-preset-${i}`,
  field: (n) => `value-calc-field-${n}`,
};

export const TENDER = {
  root: 'tender-root',
  addBtn: 'tender-add',
  packRow: (id) => `tender-pack-${id}`,
  draftIntroBtn: 'tender-draft-intro',
  introInput: 'tender-intro-input',
  saveIntroBtn: 'tender-save-intro',
  finalBtn: 'tender-mark-final',
  exportPdfBtn: 'tender-export-pdf',
  checklist: 'tender-checklist',
  checklistItem: (i) => `tender-checklist-item-${i}`,
  outcomeBadge: (id) => `tender-outcome-${id}`,
  outcomeCard: 'tender-outcome-card',
  dialog: 'tender-dialog',
  saveBtn: 'tender-save-button',
  field: (n) => `tender-field-${n}`,
};

export const CIRCULAR = {
  root: 'circular-root',
  enableBtn: 'circular-enable',
  dashboard: 'circular-dashboard',
  stat: (k) => `circular-stat-${k}`,
  targetRow: (k) => `circular-target-${k}`,
  // waste register
  wasteAddBtn: 'circular-waste-add',
  wasteRow: (id) => `circular-waste-row-${id}`,
  wasteEditBtn: (id) => `circular-waste-edit-${id}`,
  wasteDeleteBtn: (id) => `circular-waste-delete-${id}`,
  wasteDialog: 'circular-waste-dialog',
  wasteSaveBtn: 'circular-waste-save',
  wasteField: (n) => `circular-waste-field-${n}`,
  wastePhoto: 'circular-waste-photo',
  // carpet
  carpetAddBtn: 'circular-carpet-add',
  carpetRow: (id) => `circular-carpet-row-${id}`,
  carpetEditBtn: (id) => `circular-carpet-edit-${id}`,
  carpetDeleteBtn: (id) => `circular-carpet-delete-${id}`,
  carpetDialog: 'circular-carpet-dialog',
  carpetSaveBtn: 'circular-carpet-save',
  carpetField: (n) => `circular-carpet-field-${n}`,
  carpetPhoto: 'circular-carpet-photo',
  pathwaySplit: 'circular-pathway-split',
  splitField: (p) => `circular-split-${p}`,
  splitEditBtn: 'circular-split-edit',
  splitSaveBtn: 'circular-split-save',
  splitDialog: 'circular-split-dialog',
  // targets + partner
  targetsBtn: 'circular-targets-edit',
  targetsDialog: 'circular-targets-dialog',
  targetsSaveBtn: 'circular-targets-save',
  targetField: (k) => `circular-target-field-${k}`,
  partnerBtn: 'circular-partner-edit',
  partnerDialog: 'circular-partner-dialog',
  partnerSaveBtn: 'circular-partner-save',
  partnerField: (n) => `circular-partner-field-${n}`,
  // reports
  reportDraftBtn: (k) => `circular-report-draft-${k}`,
  reportInput: (k) => `circular-report-input-${k}`,
  reportSaveBtn: (k) => `circular-report-save-${k}`,
};

export const METHOD = {
  root: 'method-root',
  base: (code) => `method-base-${code}`,
  anchor0: (code) => `method-anchor0-${code}`,
  anchor100: (code) => `method-anchor100-${code}`,
  budget: (p) => `method-budget-${p}`,
  notes: 'method-notes',
  publishBtn: 'method-publish',
  confirmPublish: 'method-confirm-publish',
  resetBtn: 'method-reset',
};

export const TOWER = {
  root: 'tower-root',
  periodSelect: 'tower-period-select',
  avgTile: 'tower-avg-tile',
  row: (id) => `tower-row-${id}`,
  trendRow: (id) => `tower-trend-${id}`,
};

export const SCORE = {
  root: 'score-root',
  periodSelect: 'score-period-select',
  newPeriodBtn: 'score-new-period',
  periodDialog: 'score-period-dialog',
  periodSaveBtn: 'score-period-save',
  field: (n) => `score-field-${n}`,
  overallTile: 'score-overall-tile',
  bandChip: 'score-band-chip',
  pillarTile: (p) => `score-pillar-${p}`,
  contribRow: (code) => `score-contrib-${code}`,
  drillBtn: (code) => `score-drill-${code}`,
  drillModal: 'score-drill-modal',
  editBtn: (code) => `score-edit-${code}`,
  entryDialog: 'score-entry-dialog',
  entrySaveBtn: 'score-entry-save',
  approveBtn: (code) => `score-approve-${code}`,
  submitBtn: 'score-submit',
  issueBtn: 'score-issue',
  rejectBtn: 'score-reject',
  criticalBtn: 'score-critical',
  criticalDialog: 'score-critical-dialog',
  remediateBtn: (id) => `score-remediate-${id}`,
  reportBtn: 'score-report-btn',
  reportModal: 'score-report-modal',
  reportEdition: (e) => `score-report-edition-${e}`,
  reportDownload: 'score-report-download',
  disclosureApprove: 'score-disclosure-approve',
  disclosureRevoke: 'score-disclosure-revoke',
  aiCard: 'score-ai-card',
  aiGenerate: 'score-ai-generate',
  aiAccept: 'score-ai-accept',
  aiDiscard: 'score-ai-discard',
  provBlock: 'score-prov-block',
  provLink: (i) => `score-prov-link-${i}`,
  provEmpty: 'score-prov-empty',
  provEmptyNone: 'score-prov-empty-none',
  sourcePickerBtn: 'score-source-picker-btn',
  sourcePicker: 'score-source-picker',
  sourceSearch: 'score-source-search',
  sourceOption: (t, id) => `score-source-opt-${t}-${id}`,
  sourceChip: (t, id) => `score-source-chip-${t}-${id}`,
  sourcePickerDone: 'score-source-picker-done',
  survivalCard: 'score-survival-card',
  survivalApply: 'score-survival-apply',
  survivalLink: 'kpi-e01-survival-link',
};

export const SURVIVAL = {
  root: 'survival-root',
  newBtn: 'survival-new-register',
  registerCard: (id) => `survival-register-${id}`,
  dialog: 'survival-register-dialog',
  saveBtn: 'survival-register-save',
  field: (n) => `survival-field-${n}`,
  detail: 'survival-detail',
  backBtn: 'survival-back',
  overall: 'survival-overall',
  tier: 'survival-tier',
  trend: 'survival-trend',
  auditItem: (id) => `survival-audit-${id}`,
  auditAddBtn: 'survival-audit-add',
  auditField: (n) => `survival-audit-field-${n}`,
  auditPhoto: 'survival-audit-photo',
  criticalFlag: 'survival-critical-flag',
  remedAddBtn: 'survival-remediation-add',
  remedItem: (id) => `survival-remediation-${id}`,
  remedResolve: (id) => `survival-remediation-resolve-${id}`,
  raiseDefectBtn: 'survival-raise-defect',
  editBaselineBtn: 'survival-edit-baseline',
};

export const STANDARDS = {
  root: 'standards-root',
  periodSelect: 'standards-period-select',
  card: (k) => `standards-card-${k}`,
  detailModal: 'standards-detail-modal',
  disclosureRow: (i) => `standards-disclosure-${i}`,
  discExpand: (i) => `standards-disc-expand-${i}`,
  discDetail: (i) => `standards-disc-detail-${i}`,
  kpiCalc: (code) => `standards-kpi-calc-${code}`,
  kpiJump: (code) => `standards-kpi-jump-${code}`,
  lushPanel: 'standards-lush-panel',
  lushSite: (id) => `standards-lush-site-${id}`,
  lushMetric: (id, key) => `standards-lush-metric-${id}-${key}`,
  aiGenerate: 'standards-ai-generate',
  aiAccept: 'standards-ai-accept',
  aiDiscard: 'standards-ai-discard',
  downloadPdf: 'standards-download-pdf',
  lias: {
    panel: 'lias-scorecard-panel',
    grade: 'lias-grade',
    finalPct: 'lias-final-pct',
    termination: 'lias-termination-flag',
    focus: 'lias-focus-badge',
    area: (k) => `lias-area-${k}`,
    kpi: (k) => `lias-kpi-${k}`,
    kpiScore: (k) => `lias-kpi-score-${k}`,
    kpiNote: (k) => `lias-kpi-note-${k}`,
    kpiSave: (k) => `lias-kpi-save-${k}`,
    kpiSignoff: (k) => `lias-kpi-signoff-${k}`,
    kpiEvidence: (k) => `lias-kpi-evidence-${k}`,
    jointSignoff: 'lias-joint-signoff-btn',
    contractorName: 'lias-contractor-name',
    comments: 'lias-signoff-comments',
    reopen: 'lias-reopen-btn',
    configBtn: 'lias-config-btn',
    configBonus: 'lias-config-bonus',
    configC: 'lias-config-c',
    configD: 'lias-config-d',
    configSave: 'lias-config-save',
    downloadPdf: 'lias-download-pdf',
  },
  leaf: {
    panel: 'leaf-scorecard-panel',
    band: 'leaf-band',
    readiness: 'leaf-readiness',
    bonus: 'leaf-bonus',
    criterion: (k) => `leaf-criterion-${k}`,
    kpi: (k) => `leaf-kpi-${k}`,
    kpiScore: (k) => `leaf-kpi-score-${k}`,
    kpiNote: (k) => `leaf-kpi-note-${k}`,
    kpiSave: (k) => `leaf-kpi-save-${k}`,
    kpiSignoff: (k) => `leaf-kpi-signoff-${k}`,
    kpiEvidence: (k) => `leaf-kpi-evidence-${k}`,
    kpiRecordDate: (k) => `leaf-rec-date-${k}`,
    kpiRecordScore: (k) => `leaf-rec-score-${k}`,
    kpiRecordNote: (k) => `leaf-rec-note-${k}`,
    kpiRecordPhoto: (k) => `leaf-rec-photo-${k}`,
    kpiRecordAdd: (k) => `leaf-rec-add-${k}`,
    kpiRecordItem: (k) => `leaf-rec-item-${k}`,
    jointSignoff: 'leaf-joint-signoff-btn',
    contractorName: 'leaf-contractor-name',
    comments: 'leaf-signoff-comments',
    reopen: 'leaf-reopen-btn',
    downloadPdf: 'leaf-download-pdf',
  },
  lstp: {
    panel: 'lstp-scorecard-panel',
    band: 'lstp-band',
    readiness: 'lstp-readiness',
    bonus: 'lstp-bonus',
    criterion: (k) => `lstp-criterion-${k}`,
    kpi: (k) => `lstp-kpi-${k}`,
    kpiScore: (k) => `lstp-kpi-score-${k}`,
    kpiNote: (k) => `lstp-kpi-note-${k}`,
    kpiSave: (k) => `lstp-kpi-save-${k}`,
    kpiSignoff: (k) => `lstp-kpi-signoff-${k}`,
    kpiEvidence: (k) => `lstp-kpi-evidence-${k}`,
    kpiRecordDate: (k) => `lstp-rec-date-${k}`,
    kpiRecordScore: (k) => `lstp-rec-score-${k}`,
    kpiRecordNote: (k) => `lstp-rec-note-${k}`,
    kpiRecordPhoto: (k) => `lstp-rec-photo-${k}`,
    kpiRecordAdd: (k) => `lstp-rec-add-${k}`,
    kpiRecordItem: (k) => `lstp-rec-item-${k}`,
    jointSignoff: 'lstp-joint-signoff-btn',
    contractorName: 'lstp-contractor-name',
    comments: 'lstp-signoff-comments',
    reopen: 'lstp-reopen-btn',
    downloadPdf: 'lstp-download-pdf',
  },
};

export const EVIDENCE = {
  root: 'evidence-root',
  generateBtn: 'evidence-generate',
  packRow: (id) => `evidence-pack-${id}`,
  draftAiBtn: 'evidence-draft-ai',
  acceptNarrativeBtn: 'evidence-accept-narrative',
  narrativeInput: 'evidence-narrative-input',
  submitReviewBtn: 'evidence-submit-review',
  approveBtn: 'evidence-client-approve',
  releaseBtn: 'evidence-release',
  exportPdfBtn: 'evidence-export-pdf',
  exportJsonBtn: 'evidence-export-json',
  traceBtn: (id) => `evidence-trace-${id}`,
  traceModal: 'evidence-trace-modal',
  annotatePhotoBtn: (id) => `evidence-annotate-${id}`,
  compareBtn: (id) => `evidence-compare-${id}`,
  revertBtn: (id) => `evidence-revert-${id}`,
  captionInput: (id) => `evidence-caption-${id}`,
  captionSaveBtn: (id) => `evidence-caption-save-${id}`,
  field: (n) => `evidence-field-${n}`,
};
